module.exports = __webpack_public_path__ + "img/control_back.abc1137c.png";